"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _theme = require("../theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AccountMenu(_ref) {
  var anchorRef = _ref.anchorRef,
    onBecomeAssistant = _ref.onBecomeAssistant,
    onCloseAssistant = _ref.onCloseAssistant,
    onClose = _ref.onClose,
    onSignOut = _ref.onSignOut;
  var _a, _b, _c, _d, _e;
  var themeContext = (0, _react.useContext)(_theme.AppThemeContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var assistantOf = (_b = (_a = context.access) === null || _a === void 0 ? void 0 : _a.assistant_of) !== null && _b !== void 0 ? _b : [];
  var assistingTo = (_c = context.access) === null || _c === void 0 ? void 0 : _c.assisting_to;
  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
      onClose();
    }
  };
  var toggleTheme = function toggleTheme() {
    themeContext.toggle();
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.PopperMenu, {
    placement: "bottom-end",
    onClose: onClose,
    anchorRef: anchorRef
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuList, {
    autoFocusItem: true,
    id: "account-menu",
    onKeyDown: handleListKeyDown
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    component: _reactRouterDom.Link,
    to: context.fixPath('/profile'),
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.UserIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('users.profile.title'))), /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    component: _reactRouterDom.Link,
    to: context.fixPath('/security'),
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.SecurityIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('users.security.title'))), assistantOf.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.Divider, null), assistantOf.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    disabled: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('assistants.assistant_of'))), assistantOf.map(function (assistant) {
    var _a, _b;
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: assistant.id,
      onClick: function onClick() {
        return onBecomeAssistant(assistant);
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.AssistantsIcon, {
      fontSize: "small",
      color: "primary"
    })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "inherit"
    }, (_b = (_a = assistant.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : assistant.id));
  }), !!assistingTo && /*#__PURE__*/_react["default"].createElement(_material.Divider, null), assistingTo && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    onClick: onCloseAssistant
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.ExitIcon, {
    fontSize: "small",
    color: "inherit"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)(assistingTo.type === 'regular' ? 'assistants.close_assisting' : 'assistants.support.close', {
    name: (_e = (_d = assistingTo.user) === null || _d === void 0 ? void 0 : _d.first_name) !== null && _e !== void 0 ? _e : '---'
  }))), (assistantOf.length > 0 || !!assistingTo) && /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    onClick: toggleTheme
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, themeContext.current === 'light' ? /*#__PURE__*/_react["default"].createElement(_commons.DarkModeIcon, {
    fontSize: "small",
    color: "inherit"
  }) : /*#__PURE__*/_react["default"].createElement(_commons.LightModeIcon, {
    fontSize: "small",
    color: "warning"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)("theme.".concat(themeContext.current)))), /*#__PURE__*/_react["default"].createElement(_material.Divider, null), /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    onClick: onSignOut
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.LogoutIcon, {
    fontSize: "small",
    color: "secondary"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('buttons.signout')))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AccountMenu);